import { render, staticRenderFns } from "./AddSurvey.vue?vue&type=template&id=752e45eb&"
import script from "./AddSurvey.vue?vue&type=script&lang=js&"
export * from "./AddSurvey.vue?vue&type=script&lang=js&"
import style0 from "./AddSurvey.vue?vue&type=style&index=0&id=752e45eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports